import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { StockReplenishmentListResponse, StockReplenishmentQueryParams } from '@frontend/stock/types';

export class StockReplenishmentClient extends APIClient {
    public static readonly endpoint = '/stock-api/v1';

    public static async fetchReplenishment(queryParams?: ApiQueryParams<StockReplenishmentQueryParams>): Promise<StockReplenishmentListResponse> {
        return await this.apiPaginated<StockReplenishmentListResponse, StockReplenishmentQueryParams>(`${this.endpoint}/replenishment`, queryParams);
    }

    public static async fetchStockReplenishments(
        accounId: string,
        spotId: string,
        queryParams?: ApiQueryParams<StockReplenishmentQueryParams>,
        withCredentials?: Token
    ): Promise<StockReplenishmentListResponse> {
        return await this.apiPaginated<StockReplenishmentListResponse, StockReplenishmentQueryParams>(
            `${this.endpoint}/accounts/${accounId}/spots/${spotId}/replenishment`,
            queryParams,
            withCredentials
        );
    }
}
